import { Controller } from '@hotwired/stimulus'
import { applyAllDay } from '../tour_plan_date_all_day'

// C-4 (#13048 CA1-2): モーダル内の「見学候補日（複数）」フォームに行を動的に追加する。
// nested attributes のキー（[tour_plan_dates_attributes][N]）が一意になるように
// row-index-value を維持し、append のたびにインクリメントする。
export default class extends Controller {
  static values = {
    rowIndex: Number,
  }

  append (event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const container = this.element.querySelector('[data-tour-plan-dates-container]')
    if (!container) return

    const idx = this.rowIndexValue
    const baseName = `new_tour_plan[tour_plan_dates_attributes][${idx}]`
    const baseId = `new_tour_plan_tour_plan_dates_attributes_${idx}`

    const row = document.createElement('div')
    row.className = 'tour-plan-date-row mb-2'
    row.dataset.tourPlanDateRow = 'true'

    // position の hidden（id は新規行なので持たせない）
    const positionInput = document.createElement('input')
    positionInput.type = 'hidden'
    positionInput.name = `${baseName}[position]`
    positionInput.id = `${baseId}_position`
    positionInput.value = String(idx)
    row.appendChild(positionInput)

    const wrapper = document.createElement('div')
    wrapper.className = 'd-flex align-items-center gap-2'

    const startInput = document.createElement('input')
    startInput.type = 'datetime-local'
    startInput.name = `${baseName}[start_at]`
    startInput.id = `${baseId}_start_at`
    startInput.className = 'form-control tour-plan-date-start-at'
    wrapper.appendChild(startInput)

    const separator = document.createElement('span')
    separator.className = 'mx-1'
    separator.textContent = '〜'
    wrapper.appendChild(separator)

    const endInput = document.createElement('input')
    endInput.type = 'datetime-local'
    endInput.name = `${baseName}[end_at]`
    endInput.id = `${baseId}_end_at`
    endInput.className = 'form-control tour-plan-date-end-at'
    wrapper.appendChild(endInput)

    // Issue #13241: 「終日」チェックで 00:00〜23:59 を自動入力する。
    const allDayLabel = document.createElement('label')
    allDayLabel.className = 'ml-2 mb-0 small'
    const allDayCheckbox = document.createElement('input')
    allDayCheckbox.type = 'checkbox'
    allDayCheckbox.className = 'mr-1'
    allDayCheckbox.dataset.action = 'change->admin--ca--request--new-tour-plan--tour-plan-dates--component#toggleAllDay'
    allDayLabel.appendChild(allDayCheckbox)
    allDayLabel.appendChild(document.createTextNode('終日'))
    wrapper.appendChild(allDayLabel)

    row.appendChild(wrapper)
    container.appendChild(row)

    this.rowIndexValue = idx + 1
  }

  // Issue #13241: モーダル行の「終日」チェックで、その行の開始時刻を 00:00・終了時刻を 23:59 にする。
  toggleAllDay (event) {
    const checkbox = event.target
    const row = checkbox.closest('[data-tour-plan-date-row]')
    if (!row) return

    const start = row.querySelector('.tour-plan-date-start-at')
    const end = row.querySelector('.tour-plan-date-end-at')
    applyAllDay(start, end, checkbox.checked)
  }
}
